import { createReducer, on } from "@ngrx/store";
import { findBenefitCatalogAct, loadBenefitCatalogByIdAct, resetBenefitCatalogAct, saveSuccessBenefitCatalogAct, setViolationsBenefitCatalogAct, showMsgErrorAct, updateSuccessBenefitCatalogAct } from "./benefit-catalog.action";
import { Benefit } from "../../models/benefit";

const benefit: Benefit = new Benefit();

export const BenefitCatalogReducer = createReducer (
    {
        benefit,
        violations: {},
        loading: true 
    },
    on(resetBenefitCatalogAct, (state) => ({
        benefit:  { ...benefit },
        violations: {},
        loading: state.loading
    })),
    on(findBenefitCatalogAct, (state, { id }) =>({
        benefit: { ...benefit}, 
        violations: state.violations,
        loading: true
    })),
    on(loadBenefitCatalogByIdAct, (state, { benefit }) =>({
        benefit: { ...benefit}, 
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessBenefitCatalogAct, (state, { benefitNew }) => ({
        benefit: { ...benefitNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessBenefitCatalogAct, (state, { benefitUpdated }) => ({
        benefit: { ...benefitUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsBenefitCatalogAct, (state, { benefitForm, violations }) => ({
        benefit: { ...benefitForm },
        violations: {...violations},
        loading: false
    })),
    on(showMsgErrorAct, (state, { error }) => ({
        benefit: state.benefit,
        violations: {},
        loading: false
    }))
)